// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ndbc","col":"styles_col__2SA3y"};